var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(
      !this.$store.getters.iframeColidee
    )?_c('Header',{attrs:{"window":_vm.window,"parameters":'adminPage'}}):_vm._e(),_vm._v(" "),_c('div',{class:!this.$store.getters.iframeColidee
        ? _vm.window.width < 480
          ? 'container-fluid'
          : 'container mt-1 mb-3'
        : ''},[(
       this.$store.getters.iframeColidee && _vm.adminActiveComponents.parameters
      )?_c('ButtonReturnColidee',{attrs:{"adminComponent":true}}):_vm._e(),_vm._v(" "),(_vm.adminActiveComponents.searchBar)?_c('SearchBar'):_vm._e(),_vm._v(" "),(_vm.adminActiveComponents.cardList)?_c('CardsList',{staticClass:"card",staticStyle:{"background":"#fff"},attrs:{"window":_vm.window}}):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.adminActiveComponents.parameters)?_c('Parameters',{staticClass:"card",staticStyle:{"background":"#fff"}}):_vm._e()],1),_vm._v(" "),(
      !this.$store.getters.iframeColidee
    )?_c('MyFooter',{attrs:{"window":_vm.window}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a646359","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/page/Admin.vue
// module id = null
// module chunks = 